export const pageFadeTimeout = 400;

export const inputFadeTimeout = 250;

export const longLabelInputStyling = {
  "& .MuiFormLabel-root": { whiteSpace: "normal" },
  "& .MuiFormLabel-root.MuiInputLabel-shrink": { whiteSpace: "nowrap" },
};

export const parrotImageStyling = { borderRadius: "5px", height: "400px" };

export const pageWidth = "600px";
